// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--2Q3RK","activeLink":"header-module--activeLink--1_G11"};